export class SetWithExpiration<T> {
  private ttlMillis: number
  private data: Map<T, number>

  constructor(ttlMillis: number, checkIntervalMillis: number) {
    this.ttlMillis = ttlMillis
    this.data = new Map()
    setInterval(() => this.checkExpired(), checkIntervalMillis)
  }

  public add(value: T): void {
    this.data.set(value, Date.now())
  }

  public has(value: T): boolean {
    return this.data.has(value)
  }

  private checkExpired(): void {
    const {data, ttlMillis} = this
    const now = Date.now()
    ;[...data].forEach(([k, time]) => {
      if (!time || time < now - ttlMillis) {
        data.delete(k)
      }
    })
  }
}
